import type { IndexStyle } from "~/lib/types";
import type { NodeDefinition } from "~/nodes/types";

export const indexColorNode: NodeDefinition = {
  type: "indexColor",
  label: "Index Color",
  category: "Style",
  inputs: [],
  outputs: [{ key: "style", label: "Style", socket: "style" }],
  controls: [],
  defaults: {},

  compute() {
    const style: IndexStyle = { type: "index" };
    return { style };
  },
};
